import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import Home from './Pages/Home.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Home />
  </React.StrictMode>
);